import { render } from "./CheckLicense.vue?vue&type=template&id=281572e2"
import script from "./CheckLicense.vue?vue&type=script&lang=js"
export * from "./CheckLicense.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__